import { render, staticRenderFns } from "./PageEducatorAccountVerify.vue?vue&type=template&id=2e1294e4&scoped=true&"
import script from "./PageEducatorAccountVerify.vue?vue&type=script&lang=js&"
export * from "./PageEducatorAccountVerify.vue?vue&type=script&lang=js&"
import style0 from "./PageEducatorAccountVerify.vue?vue&type=style&index=0&id=2e1294e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1294e4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardTitle,VContainer,VForm,VProgressCircular,VTextField})
